import NotFooterLayout from "layouts/NotFooterLayout";
import UpdateCampaign from "components/Campaign/UpdateCampaign";

function UpdateCampaignPage() {
  return (
    <>
      <NotFooterLayout namePage="แก้ไขแคมเปญ"  >
        <div className="layout-content">
          <UpdateCampaign />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default UpdateCampaignPage;
